<template>
    <v-sheet color="bgtopology" class="adminview ma-4 pa-4">
        <v-row justify="space-between" class="pb-6">

        <v-col class="px-6" cols="12" sm="4" md="3" lg="3" xl='2' align-self="center" >
            <v-btn block color="success" @click="showAddDialog()">
                <span class="text_btns">{{ t('buttons.add')}} </span>
            </v-btn>
        </v-col>
        
        <v-row class="ma-0" justify="end">
            <v-col class="px-6 pt-0" cols="12" sm="12" md="9" lg="9" xl='10' align-self="center">
                    <v-row class="ma-0" style="width: 100%;" justify="end">
                        <v-text-field
                        :style="!xs ? 'max-width: 400px !important; margin-top: 10px':'padding-top: 10px !important'"  
                        v-model="searchValue"
                        :label="t('search')"
                        variant="outlined"
                        density="compact"                      
                        hide-details                     
                        ></v-text-field>
                    </v-row>
            </v-col>
        </v-row>            
        </v-row>

        <v-dialog v-model="dialog" :width="width">
            <AddEditComponent :itemObject="objectItem" @closeDialog="closeDialog()"/>
        </v-dialog>

        <EasyDataTable
        :search-field="searchField"
        :search-value="searchValue"
        table-class-name="customize-table"
        show-index
        :headers="headers"
        :items="items"
        >
        <template #item-operation="item">
            <div class="operation-wrapper">
                <v-icon color="blue" @click="showEditDialog(item)" > mdi-pencil-plus </v-icon>
                <v-icon color="red" @click="showDeleDialog(item)" > mdi-delete </v-icon>
            </div>
        </template>            
        </EasyDataTable>
    </v-sheet>      
    
</template>

<script setup lang="ts">
import { computed, onMounted, ref, Ref, watch } from 'vue';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
const {xs, md,smAndDown } = useDisplay();

/********************************
 ********** COMPONENTS **********
 *******************************/
import AddEditComponent from '@/components/SmartLink/admincomponents/AddEditComponent.vue';

/********************************
 ********** INTERFACES **********
 *******************************/
import { HEADER, ALLHEADER, } from '@/interfaces/SmartLink/Tables';
import { GENERAL_EQUIPAMENT } from '@/interfaces/SmartLink/Equips';

/**
 * Ancho del dialogo, dependiendo del dispositivo donde se ve
 */
const width = computed(() => md.value?'60%':smAndDown.value?'85%':'900px');

/**
 * CREO que sirve para buscar según que columnas
 */
const searchField = ref();

/**
 * Busca dentro de la tabla el valor que se escribe aquí
 */
const searchValue = ref("");

/**
 * Mostrar el Dialogo
 */
const dialog = ref(false);

const headers: Ref<HEADER[]> = ref([]);

const HEADERS_ADMIN:ALLHEADER = {
    header : [
        { text: computed(()=> t('labels.name')),        value: "tag",           sortable: true },
        { text: computed(()=> t('labels.ip')),          value: "ip",            sortable: true },
        { text: computed(()=> t('labels.mark')),        value: "marca",         sortable: true },
        { text: computed(()=> t('labels.subtype')),     value: "rol",           sortable: true },
        { text: computed(()=> t('labels.type')),        value: "tipo",          sortable: true },
        { text: computed(()=> t('labels.snmp_conf')),   value: "snmp_conf",     sortable: true },
        { text: computed(()=> t('labels.annotation')),  value: "anotacion",     sortable: true },
        { text: computed(()=> t('labels.location')),    value: "gps",           sortable: true },
        { text: computed(()=> t('labels.operation')),   value: "operation",     sortable: false},
    ]
}

/**
 * Todo el inventario que es traido desde la STORE 
 * API: "inventario"
 */
let items   = computed(()=>store.state.arrayListItems);

/**
 * Objeto que inicializa el dialog al seleccionar alguna fila de la tabla
 */
const objectItem:Ref<GENERAL_EQUIPAMENT>    = ref({
    elemid      : 0,
    tag         : '',
    ip          : '',
    marca       : '',
    rol         : '',
    tipo        : '',
    snmp_config : '0',
    anotacion   : '{}',
    gps         : JSON.stringify({latitud: 0, longitud: 0, altitud: 0}),
})

/**
 * Darle click al boton AGREGAR, abrira el dialog y agregara al objeto
 * "objectItem", el tipo de dialogo, en este caso: 'ADD'
 */
function showAddDialog() { 
    objectItem.value['typeDialog']  = 'add';
    dialog.value                    = true;
}

/**
 * Darle click al boton EDITAR (lapiz), abrira el dialog 
 * Reemplaza el objeto "objectItem" con los valores de la fila seleccionada
 * y tambien agrega el tipo de dialogo, en este caso: 'EDIT'. 
 */
function showEditDialog(item:GENERAL_EQUIPAMENT){
    objectItem.value                = item ;
    objectItem.value['typeDialog']  = 'edit';
    dialog.value                    = true;
}

/**
 * Darle click al boton BORRAR (tacho), abrira el dialog 
 * Reemplaza el objeto "objectItem" con los valores de la fila seleccionada
 * y tambien agrega el tipo de dialogo, en este caso: 'DELETE'. 
 */
function showDeleDialog (item:GENERAL_EQUIPAMENT) { 
    objectItem.value                = item ;
    objectItem.value['typeDialog']  = 'delete';
    dialog.value                    = true;
}

/**
 * Cierra el Diálogo cambiando el valor del dialog a FALSE
 */
function closeDialog(){
    dialog.value    = false;            
}

/**
 * Cuando se cierra cualquier dialog, el objeto "objectItem"
 * regresa a su forma original
 */
function resetValues(){
    objectItem.value =  {
        elemid      : 0,
        tag         : '',
        ip          : '',
        marca       : '',
        rol         : '',
        tipo        : '',
        snmp_config : '0',
        anotacion   : '{}',
        gps         : JSON.stringify({latitud: 0, longitud: 0, altitud: 0}),
    }
}

/**
 * Cuando el valor de "dialog" es falso, llama a la funcion: "resetValues()"
 */
watch(dialog, (item) => {
    if (!item) {
        resetValues()
    }
})

onMounted(async()=>{
    headers.value = HEADERS_ADMIN['header']
    
    /**
     * Realiza el llamado a la STORE, para realizar la ACCION: "getInventoryData",
     * el cual hace un llamado a la API.
     */
    await store.dispatch('getInventoryData');
    resetValues();
})

</script>

<style>

.bodyTEXT{
    font-size: 20px;
}

.card-add-component,
.card-edit-component{
    border-radius: 10px !important;
}
.vue3-easy-data-table{
    border: none !important;
    margin: 10px 10px;
}

.customize-table {
    --easy-table-body-row-background-color: rgb(var(--v-theme-bgtopology)) !important;
    --easy-table-header-background-color: rgb(var(--v-theme-bgtopology)) !important; 
    --easy-table-header-font-color: rgb(var(--v-theme-colorText))!important;
    --easy-table-body-row-font-color: rgb(var(--v-theme-colorText))!important;
    --easy-table-body-row-hover-font-color:rgb(var(--v-theme-colorText))!important;
    --easy-table-body-row-hover-background-color: transparent !important;
    border-bottom-color:  rgb(var(--v-theme-colorText))!important;
}
.vue3-easy-data-table__main{
    min-height: 100px !important;
}
.customize-table tbody tr:hover{
    cursor: pointer !important;
}

.adminview{
 padding: 32px;
 margin: 32px;
 border-radius: 10px;
}
.adminview .vue3-easy-data-table th:last-child span{
    justify-content: center !important;
}
.vue3-easy-data-table {
    margin: 0 !important;
}

.operation-wrapper{
    text-align: center;
}
</style>